module.exports = __webpack_public_path__ + "img/Rejected.5269592d.png";